import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const NatureResponsibleTableContent = ({ data, boName }) => {
    const [limit, setLimit] = useState(10)
    const passedLimit = data.boByNatureAndResponsible.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 10)
    }

    useEffect(() => {
        const labels = ["Natureza", "Responsável", `Total ${boName}`];
        const values = [];

        const sorted = [...(data.boByNatureAndResponsible || [])];

        sorted.forEach((element) => {
            values.push([
                element.reason_name,
                element.responsible,
                element.total_bos
            ]);
        });

        ReportUtils.createExportableTable(labels, values, 'Natureza e responsável');
    }, [data]);

    return (
        <>
            <div id="bo-nature-responsible-table">
                <div className="chart mt-3 mb-3">
                    <span className="chart-title">Total de {boName} por natureza e responsável {(passedLimit && limit) ? "(TOP 10)" : ""}</span>
                </div>

                <table id={'bo-nature-responsible-data'} className="table report-table" sheet-name={'Natureza e responsável'}>
                    <thead className="thead-background">
                        <tr className={"text-left"}>
                            <th className={'w-[30%]'}>Natureza</th>
                            <th className={'w-[50%]'}>Responsável</th>
                            <th className={'w-[20%] text-center'}>Total {boName}</th>
                        </tr>
                    </thead>

                    <tbody className="bg-white">
                        {  (limit ? data.boByNatureAndResponsible.slice(0, limit) : data.boByNatureAndResponsible).map((element, index) => {
                            return (
                                <tr key={index}>
                                    <td className={'w-[30%]'}>{element.reason_name}</td>
                                    <td className={'w-[50%]'}>{element.responsible}</td>
                                    <td className={'w-[20%] text-center'}>{element.total_bos}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1 mb-3">
                        <span id="toggle-nature" className="see-more print-hide" onClick={seeMoreOrLess}>
                            { limit ? "Ver mais" : "Ver menos" }
                        </span>
                    </div>
                }

                <span className="obs-warn mt-1">* {boName} com mais de uma Natureza serão contabilizados uma vez para cada Natureza.</span>
            </div>
        </>
    );
};

export default NatureResponsibleTableContent;